import { render } from "./Bandwidth.vue?vue&type=template&id=ca0c1af4&scoped=true"
import script from "./Bandwidth.vue?vue&type=script&lang=js"
export * from "./Bandwidth.vue?vue&type=script&lang=js"

import "./Bandwidth.vue?vue&type=style&index=0&id=ca0c1af4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0c1af4"]])

export default __exports__